import React, { FC } from "react";
import classNames from "classnames";
import Icon from "../Icon";

type Props = {
  text: string;
  color: string;
  icon?: string;
  direction?: "left" | "right";
  className?: string;
  dataTest?: string;
};

export const Pill: FC<Props> = ({
  text,
  icon,
  color,
  direction = "left",
  className,
  dataTest,
}) => {
  return (
    <div
      className={classNames(
        "flex gap-2 items-center",
        direction === "left" ? "flex-row" : "flex-row-reverse",
        color,
        className
      )}
      data-test={dataTest}
    >
      {icon && <Icon icon={icon} size={24} className={color} disableFill />}

      <span
        className="font-manrope text-base font-semibold"
        data-test={`${dataTest}-text`}
      >
        {text}
      </span>
    </div>
  );
};
